import { ContractType } from "@store/graphql/helpers/types.graphql";
import { useAtom, atom } from "@libraries/jotai";

const contractsAtom = atom<ContractType[]>([]);
const filteredContractsAtom = atom<ContractType[]>([]);

export default function useContracts() {
  const [value, setValue] = useAtom(contractsAtom);
  const [filteredContracts, setFilteredContracts] = useAtom(
    filteredContractsAtom
  );

  return { value, setValue, filteredContracts, setFilteredContracts };
}
